import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=a3c76e0a&"
import script from "./CourseIndex.vue?vue&type=script&lang=js&"
export * from "./CourseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports